import Rollbar from 'rollbar'
import config from 'config'

let rollbar = {error: () => 'Missing configuration: rollbarTokenClient and rollbarTokenServer'}

const _isSensitiveInput = input =>
  input.classes && input.classes.some(c =>
    c.toLowerCase() === 'inspectletignore',
  )

if (config && config.rollbarTokenClient && config.rollbarTokenServer) {
  const accessToken = typeof window !== 'undefined' ? config.rollbarTokenClient : config.rollbarTokenServer

  rollbar = new Rollbar({
    accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    telemetryScrubber: _isSensitiveInput,
    payload: {environment: config.rollbarEnv}
  })
}

export {_isSensitiveInput, rollbar}

export default rollbar
